import { render, staticRenderFns } from "./StaffMembers.vue?vue&type=template&id=63869c03&scoped=true&"
import script from "./StaffMembers.vue?vue&type=script&lang=js&"
export * from "./StaffMembers.vue?vue&type=script&lang=js&"
import style0 from "./StaffMembers.vue?vue&type=style&index=0&id=63869c03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63869c03",
  null
  
)

export default component.exports